import React from "react";
import styled, { css } from "styled-components/macro";
import { space, color } from "styled-system";
import { Cloudinary } from "cloudinary-core";
import Link from "./Link";
import forwardProps from "../utils/forwardProps";

const cloudinary = new Cloudinary({ cloud_name: "unserwein" });

const CardOuter = styled.div`
  display: block;
  text-decoration: none;
  background-size: cover;
  background-position: 50% 25%;
  ${space}
  ${color}
  ${props =>
    props.withBackground
      ? css`
          color: ${({ theme }) => theme.colors.textOnDark};
          text-shadow: 1px 1px ${({ theme }) => theme.colors.textOnLight};
        `
      : ""};
`;

const CardInner = styled.div(
  props =>
    css`
      ${space}
      display: flex;
      flex-direction: row;
      align-items: center;
      transition: background-color 0.3s ease-out;
      background-color: ${props.withBackground
        ? "rgba(0,0,0,0.5);"
        : "rgba(0,0,0,0)"};
      ${props.withBorder ? `border: 1px solid #ddd;` : ""}

      :hover {
        background-color: ${props.withBackground
          ? "rgba(0,0,0,0.3);"
          : "rgba(0,0,0,0.1)"};
      }
    `
);

const CleanedLink = forwardProps(name => name !== "withBackground")(Link);

function Card({ children, withBorder, backgroundImage, to, bg, mb = 3 }) {
  const publicId = backgroundImage && backgroundImage.publicId;
  const hasBackground = !!publicId;
  const url =
    publicId &&
    cloudinary.url(publicId, {
      gravity: "faces:center",
      crop: "fill",
      width: 960,
      dpr: "2.0",
      aspectRatio: "4:1",
      format: backgroundImage.format,
      fetchFormat: "auto",
      responsive: true
    });
  const style = url && { backgroundImage: `url(${url})` };

  return (
    <CardOuter
      to={to}
      as={to && CleanedLink}
      withBackground={!!hasBackground}
      style={style}
      color={hasBackground ? "textOnDark" : "text"}
      bg={bg}
      mb={mb}
      className="cld-responsive"
      variant="basic" // Set the link variant to not use hover states.
    >
      <CardInner withBackground={!!hasBackground} withBorder={withBorder} p={3}>
        {children}
      </CardInner>
    </CardOuter>
  );
}

export default Card;
